<template>
    <div>
        <!--Start Middle content-->
        <!--Start internal page banner section-->
        <section class="internal-page-banner-main col-12">
            <div class="container">
                <div class="row">
                    <div class="page-title">
                        <h1> 401k Videos
                            <div class="col-12 col-sm-12 col-md-3 col-lg-3 pull-right">
                                <v-select  class="" v-model="categoryId"
                                           @change="changedValue"
                                           @input="changedCategoryFor()"
                                           name="categoryId"
                                           id="categoryId"
                                           label="text"
                                           :filterable="false"
                                           :options="categoryArr"
                                           @search="onSearchCategory"
                                           placeholder="Select Category">
                                    <template slot="no-options">
                                        Search Parent Category...
                                    </template>
                                    <template slot="option" slot-scope="option">
                                        <div class="d-center">
                                            {{ option.text }}
                                        </div>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        <div class="selected d-center">
                                            {{ option.text }}
                                        </div>
                                    </template>
                                </v-select>
                            </div>
                            <div v-if="role.id <= 1" class="col-12 col-sm-12 col-md-2 col-lg-2 pull-right">
                                <v-select v-model="locationType"
                                          name="locationType"
                                          id="locationType"
                                          label="text"
                                          :clearable="false"
                                          :searchable="false"
                                          :filterable="false"
                                          :options="locationTypeArr"
                                          placeholder="Select Location Type">
                                </v-select>
                            </div>
                        </h1>
                    </div>
                </div>
            </div>
        </section>
        <!--End internal page banner section-->
        <div class="internal-page-main-section col-12">
            <div class="container">
                <div class="row">
                    <!--<div class="select-development-box-main col-12 float-r">
                        <div class="row">
                            <p class="color-888888 heading-text-14 line-height-16 font-text-semi-medium-mont float-l pt-12 pr-20"> Select One Category: </p>
                            <v-select  class="leadership-category pull-right" v-model="categoryId"
                                       @change="changedValue"
                                       @input="changedCategoryFor()"
                                       name="categoryId"
                                       id="categoryId"
                                       label="text"
                                       :filterable="false"
                                       :options="categoryArr"
                                       @search="onSearchCategory"
                                       placeholder="Select Parent Category">
                                <template slot="no-options">
                                    Search Parent Category...
                                </template>
                                <template slot="option" slot-scope="option">
                                    <div class="d-center">
                                        {{ option.text }}
                                    </div>
                                </template>
                                <template slot="selected-option" slot-scope="option">
                                    <div class="selected d-center">
                                        {{ option.text }}
                                    </div>
                                </template>
                            </v-select>
                        </div>
                    </div>-->
                    <div class="dayforce-main-section col-12 float-l">
                        <div class="row">
                            <!--<div class="view-btn-small pt-20 pb-80 col-12">
                                <div class="row">
                                    <a href="#" class="hvr-sweep-to-right-blue"> Login in Dayforce </a>
                                </div>
                            </div>-->

                            <div class="row float-l width-full">
                                <template v-for="(text, index) in list401kViodes">
                                    <div class="bottom-listing-prog-des dayforce-video-detail-left col-12 col-sm-12 col-md-12 col-lg-12 float-l"> <!--First des-->
                                        <div class="daygorce-detail-inner width-full float-l">
                                            <div class="hover-home-eefect float-l width-full">
                                                <template v-if="text.image_path != ''">
                                                    <img :src="text.image_path">
                                                </template>
                                            </div>
                                            <h3 class="leading-title float-l width-full heading-text-16 line-height-20 ucase font-text-semi-medium-mont"> {{text.title}} </h3>
                                            <div v-html="text.description" class="Video401k leaning-detail float-l color-333333 heading-text-14 line-height-18 font-text-semi-medium-mont"></div>
                                            <div class="btm-video-link width-full float-l">
                                                <template v-if="text.website_link != ''">
                                                    <a class="heading-text-164 font-text-semi-medium-mont" :href="text.website_link" target="_blank"> {{websiteLinkNames[index]}} </a> <!-- <a href="https://youtu.be/Ad0NIU9TVh8" target="_blank"> https://youtu.be/Ad0NIU9TVh8 </a> -->
                                                </template>
                                                <!--<template v-else>-->
                                                <!--<a class="heading-text-164 font-text-semi-medium-mont" :href="text.video_path" target="_blank"> Click here to view video </a> &lt;!&ndash; <a href="https://youtu.be/Ad0NIU9TVh8" target="_blank"> https://youtu.be/Ad0NIU9TVh8 </a> &ndash;&gt;-->
                                                <!--</template>-->
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <!--<div class="bottom-listing-prog-des dayforce-video-detail-left col-12 col-sm-6 col-md-6 col-lg-6 float-l"> &lt;!&ndash;First des&ndash;&gt;-->
                                <!--<div class="daygorce-detail-inner width-full float-l">-->
                                <!--<div class="hover-home-eefect float-l width-full">-->
                                <!--<iframe class="width-full" width="560" height="300" src="https://www.youtube.com/embed/Ad0NIU9TVh8" frameborder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>-->
                                <!--&lt;!&ndash;<a href="https://youtu.be/Ad0NIU9TVh8" target="_blank"> <img src="/static/images/dayforce-1-img.jpg" alt="Job Req Video"> </a>&ndash;&gt;-->
                                <!--</div>-->
                                <!--<h3 class="leading-title float-l width-full heading-text-16 line-height-20 ucase font-text-semi-medium-mont"> Job Req Video </h3>-->
                                <!--<p class="leaning-detail float-l color-333333 heading-text-14 line-height-18 font-text-semi-medium-mont"> Submit a Job Requisition (Job Req) when you are ready to fill a position. This video will show you how to submit a job req through dayforce. </p>-->
                                <!--<div class="btm-video-link width-full float-l">-->
                                <!--<a class="heading-text-164 font-text-semi-medium-mont" href="https://youtu.be/Ad0NIU9TVh8" target="_blank"> Click here to view video </a> &lt;!&ndash; <a href="https://youtu.be/Ad0NIU9TVh8" target="_blank"> https://youtu.be/Ad0NIU9TVh8 </a> &ndash;&gt;-->
                                <!--</div>-->
                                <!--</div>-->
                                <!--</div> &lt;!&ndash;First des&ndash;&gt;-->
                                <!--<div class="bottom-listing-prog-des dayforce-video-detail-right col-12 col-sm-6 col-md-6 col-lg-6 float-l"> &lt;!&ndash;second des&ndash;&gt;-->
                                <!--<div class="daygorce-detail-inner width-full float-l">-->
                                <!--<div class="hover-home-eefect float-l width-full">-->
                                <!--<iframe class="width-full" width="560" height="300" src="https://www.youtube.com/embed/54Lc8uWd9sM" frameborder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>-->
                                <!--&lt;!&ndash;<a href="https://youtu.be/54Lc8uWd9sM" target="_blank"> <img src="/static/images/dayforce-2-img.jpg" alt="View Candidates"> </a>&ndash;&gt;-->
                                <!--</div>-->
                                <!--<h3 class="leading-title float-l width-full heading-text-16 line-height-20 ucase font-text-semi-medium-mont pt-28"> View Candidates </h3>-->
                                <!--<p class="leaning-detail float-l color-333333 heading-text-14 line-height-18 font-text-semi-medium-mont"> Once a job req is submitted, go to the recruiting module to view candidates. This video will show you how to navigate and view candidates that have applied. </p>-->
                                <!--<div class="btm-video-link width-full float-l">-->
                                <!--<a class="heading-text-164 font-text-semi-medium-mont" href="https://youtu.be/54Lc8uWd9sM" target="_blank"> Click here to view video </a> &lt;!&ndash; <a href="https://youtu.be/Ad0NIU9TVh8" target="_blank"> https://youtu.be/Ad0NIU9TVh8 </a> &ndash;&gt;-->
                                <!--</div>-->
                                <!--</div>-->
                                <!--</div> &lt;!&ndash;second des&ndash;&gt;-->
                                <!--<div class="bottom-listing-prog-des dayforce-video-detail-left col-12 col-sm-6 col-md-6 col-lg-6 float-l"> &lt;!&ndash;third des&ndash;&gt;-->
                                <!--<div class="daygorce-detail-inner width-full float-l">-->
                                <!--<div class="hover-home-eefect float-l width-full">-->
                                <!--<iframe class="width-full" width="560" height="300" src="https://www.youtube.com/embed/xBC6GD0-Jko" frameborder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>-->
                                <!--&lt;!&ndash;<a href="https://youtu.be/xBC6GD0-Jko" target="_blank"> <img src="/static/images/dayforce-3-img.jpg" alt="Send Offer"> </a>&ndash;&gt;-->
                                <!--</div>-->
                                <!--<h3 class="leading-title float-l width-full heading-text-16 line-height-20 ucase font-text-semi-medium-mont pt-28"> Send Offer </h3>-->
                                <!--<p class="leaning-detail float-l color-333333 heading-text-14 line-height-18 font-text-semi-medium-mont"> Once you’ve found your perfect candidate, you will need to send them an offer letter. Watch this video to learn how to send offer. </p>-->
                                <!--<div class="btm-video-link width-full float-l">-->
                                <!--<a class="heading-text-164 font-text-semi-medium-mont" href="https://youtu.be/xBC6GD0-Jko" target="_blank"> Click here to view video </a> &lt;!&ndash; <a href="https://youtu.be/Ad0NIU9TVh8" target="_blank"> https://youtu.be/Ad0NIU9TVh8 </a> &ndash;&gt;-->
                                <!--</div>-->
                                <!--</div>-->
                                <!--</div> &lt;!&ndash;third des&ndash;&gt;-->
                                <!--<div class="bottom-listing-prog-des dayforce-video-detail-right col-12 col-sm-6 col-md-6 col-lg-6 float-l"> &lt;!&ndash;forth des&ndash;&gt;-->
                                <!--<div class="daygorce-detail-inner width-full float-l">-->
                                <!--<div class="hover-home-eefect float-l width-full">-->
                                <!--<iframe class="width-full" width="560" height="300" src="https://www.youtube.com/embed/drK-MTCzJhI" frameborder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>-->
                                <!--&lt;!&ndash;<a href="https://youtu.be/drK-MTCzJhI" target="_blank"> <img src="/static/images/dayforce-4-img.jpg" alt="Hire Candidate"> </a>&ndash;&gt;-->
                                <!--</div>-->
                                <!--<h3 class="leading-title float-l width-full heading-text-16 line-height-20 ucase font-text-semi-medium-mont pt-28"> Hire Candidate </h3>-->
                                <!--<p class="leaning-detail float-l color-333333 heading-text-14 line-height-18 font-text-semi-medium-mont"> When you have confirmed start date, next step is to click the hire button. This video will go over how to locate and complete candidate hire form. </p>-->
                                <!--<div class="btm-video-link width-full float-l">-->
                                <!--<a class="heading-text-164 font-text-semi-medium-mont" href="https://youtu.be/drK-MTCzJhI" target="_blank"> Click here to view video </a> &lt;!&ndash; <a href="https://youtu.be/Ad0NIU9TVh8" target="_blank"> https://youtu.be/Ad0NIU9TVh8 </a> &ndash;&gt;-->
                                <!--</div>-->
                                <!--</div> &lt;!&ndash;forth des&ndash;&gt;-->
                                <!--</div>-->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--End Middle content-->
    </div>
</template>
<script>
    import Vue from "vue";
    import vSelect from 'vue-select';
    import SessioMixin from '../mixins/sessionmixin';
    import { HTTP } from '../http-common';
    import draggable from 'vuedraggable';
    var self;
    export default {
        name: 'dayforce101',
        components: {
            'v-select': vSelect,
            draggable,
        },
        mixins: [SessioMixin],
        data() {
            return {
                locationType: {value: 'other', text: 'Other'},
                locationTypeArr: [
                    {value: 'other', text: 'Other'},
                    {value: 'Velocity SBA', text: 'Velocity SBA'}
                ],
                roleId: 0,
                categoryId: '',
                categoryArr: [],
                categoryType: '401k',
                list401kViodes: [],
                websiteLinkNames: [],
            }
        },
        watch: {
            categoryId: function (categoryId) {
                self.get401kVideos();
            },
            locationType: function (locationType) {
                self.get401kVideos();
            },
        },
        beforeMount: function () {
            self = this;
            self.checkLogin();
        },
        mounted: function () {
            self.MenuClose();
            self.getPermissions();
            self.loadCategoryFirst();
            self.getBuildVersion();
        },

        methods: {
            formatString: function (data) {
                var value = data.replace(/_/g, " ");
                var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                    return letter.toUpperCase();
                });
                return upp;
            },
            loadCategoryFirst() {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        'type': self.categoryType,
                    }
                };
                HTTP.get("getcategory", config)
                        .then(function (response) {
                            self.categoryArr = [];
                            var addAll = {text: 'All', value: '0'};
                            self.categoryArr.push(addAll);
                            $.each(response.data.content, function (i) {
                                self.categoryArr.push(response.data.content[i]);
                            });
                            self.categoryId = addAll;
//                        self.categoryArr = response.data.content;
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
            changedValue: function (value) {
                //console.log(value);
            },
            changedCategoryFor: function () {

            },
            onSearchCategory(search, loading) {
                if (search.length >= 2) {
                    if (typeof (loading) != "undefined") {
                        loading(true);
                    }
                    this.loadCategory(loading, search, this);
                }
            },
            loadCategory(loading, search, vm) {
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")},
                    params: {
                        'type': self.categoryType,
                        'search': search,
                    }

                };
                HTTP.get("getcategory", config)
                        .then(function (response) {
                            self.categoryArr = response.data.content;
                            if (typeof (loading) != "undefined") {
                                loading(false);
                            }
                        })
                        .catch(function (err) {
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },

            get401kVideos: function () {
                var fields = {
                    categoryId: self.categoryId.value,
                    categoryType: self.categoryType,
                    location_type: self.locationType.value,
                };
                var config = {
                    headers: {Authorization: "Bearer " + localStorage.getItem("api_token")}
                };
                HTTP.post('get401kvideo/' + self.categoryId.value, fields, config).
                        then(response => {
                            self.list401kViodes = [];
                            self.websiteLinkNames = [];
                            setTimeout(function () {
                                self.list401kViodes = response.data.content;
                                // self.websiteLinkNames = self.list401kViodes[0].website_link.replace(/^(?:https?:\/\/)?/i, "").split('/')[0];
                                for (var i = 0; i < self.list401kViodes.length; i++) {
                                    self.websiteLinkNames.push(self.list401kViodes[i].website_link.replace(/^(?:https?:\/\/)?/i, "").split('/')[0]);
                                }
                            }, 100);
                        })
                        .catch(function (err) {
                            self.list401kViodes = [];
                            if (err.response.status == 0) {
                                self.error = "Remote server can not be reachable";
                            } else {
                                //redirect to login page if user not authenticated
                                if (err.response.status == 401) {
                                    //clear previous data
                                    localStorage.removeItem("user_obj");
                                    localStorage.removeItem("api_token");
                                    localStorage.removeItem("profile_image");
                                    self.$router.push("/login");
                                    //EventBus.$emit("logged-in", true, "", "");
                                }
                                self.error = err.response.data.message;
                            }
                        });
            },
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Videos401k.vue